module.exports = __webpack_public_path__ + "static/media/ibd_back2.d2f24e95.png";